// extracted by mini-css-extract-plugin
module.exports = {"button":"ButtonFilled_button__maGcQ","buttonOrange":"ButtonFilled_buttonOrange__SHffb"};